<template>
  <span
    class="status"
    :style="{ color: getFontColor(), backgroundColor: getBackgroundColor() }"
  >
    {{ getText() }}
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  methods: {
    getFontColor() {
      switch (this.status) {
        case "ACTIVE":
          return "white";
        case "PAID":
          return "white";
        case "CONFIRMED":
          return "white";
        case "CANCELED":
          return "white";
        case "PENDING":
          return "black";
        case "PRE_REGISTRATION":
          return "black";
        case "PROSPECTADO":
          return "black";
        case "RE_REGISTRATION":
          return "black";
        case "PENDENT":
          return "black";
        case "WAITING":
          return "white";
        case "BLOCKED":
          return "white";
        default:
          return "black";
      }
    },
    getBackgroundColor() {
      switch (this.status) {
        case "ACTIVE":
          return "var(--color-success)";
        case "PAID":
          return "var(--color-success)";
        case "CONFIRMED":
          return "var(--color-success)";
        case "CANCELED":
          return "var(--color-error)";
        case "PENDING":
          return "var(--color-warning)";
        case "PRE_REGISTRATION":
          return "var(--color-warning)";
        case "PROSPECTADO":
          return "#7c3aed";
        case "RE_REGISTRATION":
          return "var(--color-warning)";
        case "PENDENT":
          return "var(--color-warning)";
        case "WAITING":
          return "var(--color-info)";
        case "BLOCKED":
          return "var(--color-sidebar)";
        default:
          return "var(--color-surface-muted)";
      }
    },
    getText() {
      switch (this.status) {
        case "ACTIVE":
          return "Ativo";
        case "PAID":
          return "Pago";
        case "CONFIRMED":
          return "Confirmado";
        case "CANCELED":
          return "Cancelado";
        case "PENDING":
          return "Pendente";
        case "PENDENT":
          return "Pendente";
        case "PRE_REGISTRATION":
          return "Pré-registrado";
        case "PROSPECTADO":
          return "Prospectado";
        case "RE_REGISTRATION":
          return "Atualizar Registro";
        case "WAITING":
          return "Aguardando";
        case "BLOCKED":
          return "Bloqueado";
        case "WITHDRAWAL":
          return "Saque";
        case "PAYMENT":
          return "Pagamento";
        case "CASHBACK":
          return "Cashback";
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.status {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 5px 12px;
  border-radius: 999px;
  font-weight: 600;
}
</style>
